import PropTypes from 'prop-types';
import React, {Component} from 'react';

export const SIZE_25 = 'columns__column--25'
export const SIZE_33 = 'columns__column--33'
export const SIZE_50 = 'columns__column--50'
export const SIZE_66 = 'columns__column--66'
export const SIZE_75 = 'columns__column--75'
export const SIZE_100 = 'columns__column--100'

class Column extends Component {

    static propTypes = {
        columnWidth: PropTypes.string,
        indentLeft: PropTypes.bool,
        isSticky: PropTypes.bool,
        className: PropTypes.string
    }

    render() {

        return (

            <div
                className={
                    (this.props.columnWidth ? this.props.columnWidth : '')
                    + (this.props.indentLeft ? ' columns__column--indent-left' : '')
                    + (this.props.isSticky ? ' columns__column--sticky' : '')
                    + " columns__column"
                    + (this.props.className ? (" " + this.props.className) : "")
                }
                style={this.props.style}
            >
                {this.props.children}
            </div>

        )

    }

}

export default Column



/** WEBPACK FOOTER **
 ** ./src/components/Column.js
 **/